import "slick-carousel";
import Confetti from './confetti.js';
import {isRtl, toggleSliderNextButton, areAllSlidesVisible, isLastSlideVisibleRtl, isLastSlideVisibleLtr} from "../utils/helpers";

export default class DafLearn {
    constructor() {
        this.tabsContainer = document.querySelector('.masechet_learn__tabs--list');
        this.tabs = document.querySelectorAll('.masechet_learn__tab');
        this.pagination = document.querySelectorAll('.masechet_learn--pagination');
        this.contents = document.querySelectorAll('.masechet_learn__list--item');
        this.openPopup = document.querySelectorAll('.nav-daf__next.open-popup');
        this.certificateDownload = document.querySelectorAll('.masechet-certificate__button');

        if (this.tabs.length && this.contents.length) {
            this.init();
            this.initSlider();
            this.handleResize();
        }

        if(this.openPopup.length){
            this.navDafPopup();
        }

        if (this.certificateDownload.length) {
            this.certificateDownload.forEach(button => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.certificateButton(button);
                });
            });

            this.activateConfetti();

        }

    }

    init() {
        let pageGlobal = 1;
        let allMasechet = 0;
        const params = new URL(window.location.href).searchParams;


        this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', (e) => {
                e.preventDefault();
                this.activateTab(index);
            });
        });

        if (this.tabs.length > 0) {
            this.activateTab(0);
        }

        $('.masechet_learn--pagination').on('click', '.page-numbers:not(.prev):not(.next)', function (e){
            e.preventDefault();
            pageGlobal = $(this).text();
            allMasechet = $(this).parents('.masechet_learn__pagination--right').attr('data-all');
            getPagination();
        })

        $('.masechet_learn--pagination').on('click', '.next', function (e){
            e.preventDefault();
            pageGlobal = parseInt(pageGlobal)+1;
            allMasechet = $(this).parents('.masechet_learn__pagination--right').attr('data-all');
            getPagination();
        })

        $('.masechet_learn--pagination').on('click', '.prev', function (e){
            e.preventDefault();
            pageGlobal = parseInt(pageGlobal)-1;
            allMasechet = $(this).parents('.masechet_learn__pagination--right').attr('data-all');
            getPagination();
        })

        if($('.masechet_learn__tab[data-tab="for-beginners"]').length > 0) {
            $('.masechet_learn__tab[data-tab="for-beginners"]').click();
            $('.masechet_learn__tab[data-tab="for-beginners"]').prependTo('.masechet_learn__tabs--list');
        }

        if(params.get('tab') && $('.masechet_learn__tab[data-tab="'+params.get('tab')+'"]').length > 0){
            $('.masechet_learn__tab[data-tab="'+params.get('tab')+'"]').click();
            let top = $('.masechet_learn__tabs').offset().top - 200;
            $('body,html').animate({scrollTop: top}, 500);
        }

        function getPagination(){
            var ajaxurl = myAjax.ajaxurl;
            $.ajax({
                type: "POST",
                url: ajaxurl,
                data: {
                    "action": "masechet_paginate",
                    'all': allMasechet,
                    'page': pageGlobal
                },
                success: function (result) {
                    $('.masechet_learn--pagination.active').html(result);
                    $('.masechet_learn__list--item.active .masechet_learn__item').each(function (i,e){
                        let currentIndex = $(this).index() + 1;
                        if((currentIndex > 12 * (pageGlobal - 1)) && currentIndex <= 12 * pageGlobal){
                            $(this).removeClass('hidden')
                        }else{
                            $(this).addClass('hidden')
                        }
                    })
                }
            });
        }
    }

    activateTab(index) {
        this.deactivateAll();
        this.tabs[index].classList.add('active');
        this.contents[index].classList.add('active');
        this.pagination[index].classList.add('active');
    }

    deactivateAll() {
        this.tabs.forEach(tab => tab.classList.remove('active'));
        this.contents.forEach(content => content.classList.remove('active'));
        this.pagination.forEach(pag => pag.classList.remove('active'));
    }

    initSlider() {
        const $slider = $(this.tabsContainer);

        if (!$slider.hasClass('slick-initialized')) {
            $slider.slick({
                slidesToScroll: 1,
                slidesToShow: 1,
                infinite: false,
                arrows: true,
                mobileFirst: true,
                centerMode: true,
                rtl: isRtl(),
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            variableWidth: true,
                            centerMode: false,
                        }
                    }
                ]
            });
            
            setTimeout(() => {
                this.updateSliderNavigation($slider.slick('getSlick'));
            }, 100);
        }

        $slider.on('afterChange', (e, slick, currentSlide) => {
            this.handleAfterChange(slick, currentSlide);
        });
        
        $slider.on('init reInit', (e, slick) => {
            this.updateSliderNavigation(slick);
        });
    }

    handleAfterChange(slick, currentSlide) {
        if (window.innerWidth < 768) {
            this.activateTab(currentSlide);
        }

        this.updateSliderNavigation(slick);
    }

    updateSliderNavigation(slick) {
        const $slider = $(this.tabsContainer);
        const wraRect = $('.slick-list', $slider).get(0).getBoundingClientRect();
        const slideCount = slick.$slides.length;
        
        if (slideCount <= 1) {
            toggleSliderNextButton($slider, true);
            return;
        }

        if (slick.options.rtl) {
            const lastSlideRect = slick.$slides[slideCount - 1].getBoundingClientRect();
            toggleSliderNextButton($slider, isLastSlideVisibleRtl(lastSlideRect, wraRect));
        } else {
            const firstSlideRect = slick.$slides[0].getBoundingClientRect();
            const lastSlideRect = slick.$slides[slideCount - 1].getBoundingClientRect();
            
            if (areAllSlidesVisible(firstSlideRect, lastSlideRect, wraRect)) {
                toggleSliderNextButton($slider, true);
                return;
            }
            
            toggleSliderNextButton($slider, isLastSlideVisibleLtr(lastSlideRect, wraRect));
        }
    }

    handleResize() {
        window.addEventListener('resize', () => {
            const $slider = $(this.tabsContainer);
            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('setPosition');
                this.updateSliderNavigation($slider.slick('getSlick'));
            }
        });
    }

    navDafPopup() {
        const open_popup = this.openPopup;
        $(open_popup).on('click', function () {
            $(this).siblings('.next-daf-popup').addClass('is_open');
        })

        $(document).on('click', function(e) {
            if (!$(e.target).closest('.next-daf-popup__wrapper').length && !$(e.target).closest('.nav-daf__next').length) {
                $('.next-daf-popup.is_open').removeClass('is_open');
            }
        });

        $('.next-daf-popup__incomplete').on('click', function () {
            const navigation_url = $(this).data('navigation');

            if(navigation_url){
                window.location.href = navigation_url;
            }
        })
    }

    certificateButton(button) {

        if (!button) return;

        const masechetName = button.dataset.masechetName || 'Unnamed Masechet';

        const originalHtml = button.innerHTML;
        button.innerHTML = '<span class="loading-text">Preparing certificate...</span> <span class="loading-dots"></span>';
        button.disabled = true;
        button.classList.add('loading');

        let dotsCount = 0;
        const loadingInterval = setInterval(() => {
            dotsCount = (dotsCount + 1) % 4;
            const dots = '.'.repeat(dotsCount);
            button.querySelector('.loading-dots').textContent = dots;
        }, 300);

        const formData = new FormData();
        formData.append('action', 'download_certificate_content');
        formData.append('masechet_name', masechetName);

        fetch(myAjax.ajaxurl, {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(response => {
                if (response.success && response.data?.title && response.data?.content) {
                    const filename = `${response.data.title.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.html`;
                    const blob = new Blob([response.data.content], { type: 'text/html' });
                    const url = URL.createObjectURL(blob);

                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();

                    URL.revokeObjectURL(url);
                } else {
                    alert('Error: ' + (response.data?.message || 'Could not download certificate.'));
                }
            })
            .catch(err => {
                console.error('AJAX error:', err);
                alert('An unexpected error occurred.');
            })
            .finally(() => {
                clearInterval(loadingInterval);
                button.innerHTML = originalHtml;
                button.disabled = false;
                button.classList.remove('loading');
            });
    }

    activateConfetti() {
        const certificateButton = this.certificateDownload[0];
        const termId = certificateButton.dataset.termid;
        const userId = certificateButton.dataset.userid;
        const confettiKey = `confetti_shown_user_${userId}_term_${termId}`;

        if (!localStorage.getItem(confettiKey)) {
            Confetti.startAnimation();
            localStorage.setItem(confettiKey, 'true');
        }
    }
}